export default function () {
    return {
        autoMarketData: null,
        activeCategoryId: null,
        autoMarketCategories: null,
        autoMarketProducts: null,
    }
}
